import {endpoints} from './endpoints'
import request from '../../request'

export const createProjectColumn = (data) => {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createProjectColumn,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}
export const updateProjectColumn = (data) => {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateProjectColumn,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}
export const updateProjectColumnsPosition = (data) => {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateProjectColumnsPosition,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}
export const deleteProjectColumn = (data) => {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteProjectColumn,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}
export const setTaskColumn = (data) => {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setTaskColumn,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}
export const getProjectColumns = (params) => {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjectColumns,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}
export const updateTaskColumn = (data) => {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateTaskColumn,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}
export const getProjectKanban = (params) => {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjectKanban,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}